import type { TWarehouseTaskStatus } from 'api/swagger';

export const statusColorMap: Record<TWarehouseTaskStatus, string> = {
  waiting: '',
  progress: 'blue',
  done: 'green',
  cancelled: 'error',
};
